import { IReactConfiguration } from "../typings";
import {
  DecimalCharacter,
  UnitSystem,
} from "./controller/unit-system-controller";

export const defaultConfiguration: IReactConfiguration = {
  design: undefined,
  target: null,
  // eslint-disable-next-line camelcase
  canvas_target: "#canvas",
  // eslint-disable-next-line camelcase
  options_target: "#options",
  // eslint-disable-next-line camelcase
  fullscreen_target: "#fullscreen",
  // eslint-disable-next-line camelcase,camelcase
  pre_upload_target: "#pre-upload-canvas",
  // eslint-disable-next-line camelcase,camelcase
  canvas_only: false,
  // eslint-disable-next-line camelcase
  template_url: "assets/json/template.json",
  // eslint-disable-next-line camelcase
  unitSystem: UnitSystem.IMPERIAL,
  // eslint-disable-next-line camelcase
  asset_prefix: "/media/",
  // eslint-disable-next-line camelcase
  upload_address: undefined,
  // eslint-disable-next-line camelcase
  sessionStorage: "",
  decimalCharacter: DecimalCharacter.COLON,
  fullscreenMediaQuery: "",
  messageTarget: "#designer-error-message",
  setIncludedEdges: false,
  stickyUploadPanel: null,
};

export const dpi300Files: string[] = [
  "image/png",
  "image/gif",
  "image/bmp",
  "image/jpg",
  "image/jpeg",
  "application/tiff",
];

export const dpi72Files: string[] = ["image/gif", "image/bmp"];

export const suportedFilesWithoutConversion: string[] = [
  "image/png",
  "image/gif",
  "image/bmp",
];

export const suportedFiles: string[] = [
  ...suportedFilesWithoutConversion,
  "image/svg+xml",
  "application/pdf",
  "application/illustrator",
  "application/tiff",
  "application/x-mscardfile",
  "image/jpg",
  "image/jpeg",

  // photoshop
  "application/photoshop",
  "image/vnd.adobe.photoshop",
];
